import { isPlatform } from '@ionic/vue';
import axios from 'axios';


var apiURL ='http://localhost:8000';

if (process.env.NODE_ENV  === 'production' || process.env.NODE_ENV  ===  'staging'  )
  apiURL = '/'
else if ( (isPlatform('android') ||isPlatform('ios')) &&  process.env.NODE_ENV  === 'staging' )
  apiURL = 'https://dev.micurobene.it/'
else if ( (isPlatform('android') ||isPlatform('ios')) &&  process.env.NODE_ENV  === 'production' )
  apiURL = 'https://www.micurobene.it/'

//apiURL = 'https://www.micurobene.it/'

const instance = axios.create({
  baseURL: apiURL,
 headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + localStorage.getItem('token')
  }
});

instance.interceptors.request.use((config) => {
  config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('token')
  return config;
});

export default instance;